import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import graphQlClient from './graphql-client';
import './index.css';
import { ConfigProvider, ThemeConfig } from 'antd';
import rfsTheme from './theme';

// Antd dynamic theme.
const theme: ThemeConfig = {
  token: {
    colorPrimary: rfsTheme.darkRfsRed,
  },
  components: {
    Button: {
      borderRadius: 0,
    },
  },
};

const maybeRootElement = document.getElementById('root');

const rootElement =
  maybeRootElement === null ? document.createElement('div') : maybeRootElement;

const root = ReactDOM.createRoot(rootElement);

root.render(
  <ApolloProvider client={graphQlClient}>
    <ConfigProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </ApolloProvider>
);
